import { FpAxios } from "@/services/FpAxios";
import { FilemanagerEntry, FilemanagerEntryDTO } from "@/models/FilemanagerEntry";
import FileSaver from "file-saver";
import processProxy from "@/env/processProxy";

class FilemanagerAPI {
  // Token jest wstrzykiwany per-request przez interceptor w FpAxios (nagłówek `authorization`).
  private filemanagerAxios = FpAxios.create();
  readonly baseUrl = "filemanager";

  async readFolder(path: string): Promise<Array<FilemanagerEntry>> {
    const response = await this.filemanagerAxios.get(
      `${this.baseUrl}/readfolder/${encodeURIComponent(
        this.safeDecodeURIComponent(path)
      )}`
    );
    const filemanagerEntries: Array<FilemanagerEntryDTO> = response.data;
    filemanagerEntries.forEach((entry, index) => {
      switch (entry.name) {
        case "MBANK":
          entry.name = "MULTI";
          break;
        case "BNP":
          entry.name = "BGZ";
          break;
        case "EURO":
          filemanagerEntries.splice(index, 1);
          break;
      }
    });
    return filemanagerEntries.map(
      (filemanagerEntry: FilemanagerEntryDTO) =>
        new FilemanagerEntry(filemanagerEntry)
    );
  }

  public safeDecodeURIComponent(str: string) {
    // Replace all '%' not followed by two hex digits with '%25' (which is the encoding for '%')
    str = str.replace(/%(?![a-fA-F0-9]{2})/g, "%25");
    return decodeURIComponent(str);
  }

  async search(query: string): Promise<Array<FilemanagerEntry>> {
    const response = await this.filemanagerAxios.get<FilemanagerEntryDTO[]>(
      `${this.baseUrl}/seekfolder/${encodeURIComponent(query)}`
    );
    const filemanagerEntries: Array<FilemanagerEntryDTO> = response.data;
    return filemanagerEntries.map(
      (filemanagerEntry: FilemanagerEntryDTO) =>
        new FilemanagerEntry(filemanagerEntry)
    );
  }

  async downloadWithAuthorization(path: string) {
    if (path !== undefined) {
      const response = await this.filemanagerAxios.get<Blob>(
        `${processProxy.VUE_APP_BASE_URL}${
          this.baseUrl
        }/download/${encodeURIComponent(path)}`,
        { responseType: "blob" }
      );
      const fileName = path.split("/").pop();
      FileSaver.saveAs(response.data, fileName);
    }
  }

  async downloadSelected(paths: string[]): Promise<Blob> {
    const response = await this.filemanagerAxios.post<Blob>(
      `${this.baseUrl}/download/zip`,
      paths,
      { responseType: "blob" }
    );
    return response.data;
  }
}

export default new FilemanagerAPI();
